if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.addEventListener('click', (event) => {
          const step = event.target.closest('[data-photo-step]');
          const zoom = event.target.closest('[data-zoom-step]');
          if (step) this.cyclePhoto(Number(step.dataset.photoStep));
          if (zoom) this.setZoom(this.zoomScale + Number(zoom.dataset.zoomStep));
          if (event.target.closest('[data-zoom-reset]')) this.setZoom(1, true);
        });
        this.addEventListener('input', (event) => {
          if (event.target.matches('[data-photo-zoom]')) this.setZoom(Number(event.target.value));
        });
        this.addEventListener('wheel', this.handleWheelZoom.bind(this), { passive: false });
        this.addEventListener('keydown', (event) => {
          if (event.target.closest('input, textarea, select')) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.cyclePhoto(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || !event.target.matches('.product-media-modal__content > img.active')) return;
          event.preventDefault();
          this.zoomImage = event.target;
          this.startDrag(event);
          this.dragPointer = event.pointerId;
          event.target.setPointerCapture(event.pointerId);
        });
        this.addEventListener('pointermove', (event) => {
          if (this.dragPointer !== event.pointerId || !this.zoomImage) return;
          this.zoomX = this.gestureStartTranslateX + event.clientX - this.gestureStartX;
          this.zoomY = this.gestureStartTranslateY + event.clientY - this.gestureStartY;
          this.constrainZoom();
          this.applyZoom();
        });
        const endDrag = () => { this.dragPointer = null; };
        this.addEventListener('pointerup', endDrag);
        this.addEventListener('pointercancel', endDrag);
        this.addEventListener('dragstart', (event) => event.preventDefault());
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;
        this.appliedZoomX = 0;
        this.appliedZoomY = 0;
        this.zoomImage = null;
        this.pinchStartDistance = 0;
        this.pinchStartScale = 1;
        this.pinchFocalX = 0;
        this.pinchFocalY = 0;
        this.gestureStartX = 0;
        this.gestureStartY = 0;
        this.gestureStartTranslateX = 0;
        this.gestureStartTranslateY = 0;

        this.addEventListener('touchstart', this.handleZoomStart.bind(this), { passive: false });
        this.addEventListener('touchmove', this.handleZoomMove.bind(this), { passive: false });
        this.addEventListener('touchend', this.handleZoomEnd.bind(this), { passive: false });
        this.addEventListener('touchcancel', this.handleZoomEnd.bind(this), { passive: false });
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      mediaItems() {
        return Array.from(this.querySelector('.product-media-modal__content').children).filter(item => item.hasAttribute('data-media-id'));
      }

      showActiveMedia() {
        const items = this.mediaItems();
        const id = this.openedBy.getAttribute('data-media-id');
        const index = items.findIndex(item => item.dataset.mediaId === id);
        this.activateMedia(index < 0 ? 0 : index);
      }

      activateMedia(index) {
        const items = this.mediaItems();
        if (!items.length) return;
        this.resetZoom();
        window.pauseAllMedia();
        this.mediaIndex = (index + items.length) % items.length;
        items.forEach((item, i) => {
          item.classList.toggle('active', i === this.mediaIndex);
          item.setAttribute('aria-hidden', i === this.mediaIndex ? 'false' : 'true');
        });
        const active = items[this.mediaIndex];
        this.zoomImage = active.tagName === 'IMG' ? active : null;
        if (this.zoomImage) {
          this.zoomImage.draggable = false;
          this.zoomImage.addEventListener('load', () => { this.constrainZoom(); this.applyZoom(); }, { once: true });
        }
        this.querySelector('[data-photo-count]').textContent = (this.mediaIndex + 1) + ' / ' + items.length;
        this.querySelectorAll('[data-photo-step]').forEach(button => { button.disabled = items.length < 2; });
        this.updateZoomControls();
      }

      cyclePhoto(step) {
        this.activateMedia((this.mediaIndex || 0) + step);
      }

      setZoom(scale, resetPosition = false) {
        if (!this.zoomImage) return;
        this.zoomScale = Math.min(5, Math.max(0.2, scale));
        if (resetPosition) { this.zoomX = 0; this.zoomY = 0; }
        this.constrainZoom();
        this.applyZoom();
      }

      handleWheelZoom(event) {
        if (!this.hasAttribute('open') || !this.zoomImage ||
            !event.target.closest('.product-media-modal__content') || event.deltaY === 0) return;
        event.preventDefault();
        const pixels = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? 240 : 1);
        const scale = Math.min(5, Math.max(0.2, this.zoomScale * Math.exp(-Math.max(-240, Math.min(240, pixels)) * 0.002)));
        const rect = this.zoomImage.getBoundingClientRect();
        const focalX = (event.clientX - rect.left - rect.width / 2) / this.zoomScale;
        const focalY = (event.clientY - rect.top - rect.height / 2) / this.zoomScale;
        this.zoomX += focalX * (this.zoomScale - scale);
        this.zoomY += focalY * (this.zoomScale - scale);
        this.zoomScale = scale;
        this.constrainZoom();
        this.applyZoom();
      }

      updateZoomControls() {
        const slider = this.querySelector('[data-photo-zoom]');
        if (!slider) return;
        slider.value = this.zoomScale;
        slider.disabled = !this.zoomImage;
        this.querySelector('[data-zoom-value]').textContent = Math.round(this.zoomScale * 100) + '%';
        this.querySelectorAll('[data-zoom-step], [data-zoom-reset]').forEach(button => { button.disabled = !this.zoomImage; });
      }

      activeZoomImage(event) {
        return (
          event.target.closest('.product-media-modal__content img[data-media-id]') ||
          this.querySelector('.product-media-modal__content [data-media-id].active img[data-media-id]') ||
          this.querySelector('.product-media-modal__content img[data-media-id]')
        );
      }

      handleZoomStart(event) {
        if (window.innerWidth >= 750) return;
        if (event.target.closest('button, a, input, select, textarea, [role="button"]')) return;

        const image = this.activeZoomImage(event);
        if (!image) return;

        this.zoomImage = image;

        if (event.touches.length === 2) {
          event.preventDefault();
          this.pinchStartDistance = this.touchDistance(event.touches);
          this.pinchStartScale = this.zoomScale;

          const midpoint = this.touchMidpoint(event.touches);
          const rect = image.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;

          this.pinchFocalX = (midpoint.x - centerX) / this.zoomScale;
          this.pinchFocalY = (midpoint.y - centerY) / this.zoomScale;
        } else if (event.touches.length === 1) {
          event.preventDefault();
          this.startDrag(event.touches[0]);
          this.zoomImage.classList.add('is-pinch-zoomed');
        }
      }

      handleZoomMove(event) {
        if (window.innerWidth >= 750 || !this.zoomImage) return;

        if (event.touches.length === 2) {
          event.preventDefault();

          const distance = this.touchDistance(event.touches);
          const midpoint = this.touchMidpoint(event.touches);
          const newScale = Math.min(
            5,
            Math.max(0.2, this.pinchStartScale * (distance / this.pinchStartDistance))
          );
          const rect = this.zoomImage.getBoundingClientRect();
          const renderedCenterX = rect.left + rect.width / 2;
          const renderedCenterY = rect.top + rect.height / 2;
          const untransformedCenterX = renderedCenterX - this.zoomX;
          const untransformedCenterY = renderedCenterY - this.zoomY;

          this.zoomScale = newScale;
          this.zoomX = midpoint.x - untransformedCenterX - this.pinchFocalX * newScale;
          this.zoomY = midpoint.y - untransformedCenterY - this.pinchFocalY * newScale;
          this.constrainZoom();
          this.applyZoom();
        } else if (event.touches.length === 1) {
          event.preventDefault();
          this.zoomX = this.gestureStartTranslateX + event.touches[0].clientX - this.gestureStartX;
          this.zoomY = this.gestureStartTranslateY + event.touches[0].clientY - this.gestureStartY;
          this.constrainZoom();
          this.applyZoom();
        }
      }

      handleZoomEnd(event) {
        if (!this.zoomImage) return;

        if (event.touches.length === 1) {
          event.preventDefault();
          this.startDrag(event.touches[0]);
        }
      }

      startDrag(touch) {
        this.gestureStartX = touch.clientX;
        this.gestureStartY = touch.clientY;
        this.gestureStartTranslateX = this.zoomX;
        this.gestureStartTranslateY = this.zoomY;
      }

      touchDistance(touches) {
        return Math.hypot(
          touches[1].clientX - touches[0].clientX,
          touches[1].clientY - touches[0].clientY
        );
      }

      touchMidpoint(touches) {
        return {
          x: (touches[0].clientX + touches[1].clientX) / 2,
          y: (touches[0].clientY + touches[1].clientY) / 2,
        };
      }

      constrainZoom() {
        if (!this.zoomImage) return;

        const viewport = this.querySelector('.product-media-modal__content').getBoundingClientRect();
        const rect = this.zoomImage.getBoundingClientRect();
        const scaledWidth = this.zoomImage.offsetWidth * this.zoomScale;
        const scaledHeight = this.zoomImage.offsetHeight * this.zoomScale;
        const baseCenterX = rect.left + rect.width / 2 - this.appliedZoomX;
        const baseCenterY = rect.top + rect.height / 2 - this.appliedZoomY;

        let minCenterX;
        let maxCenterX;
        let minCenterY;
        let maxCenterY;

        if (scaledWidth <= viewport.width) {
          minCenterX = viewport.left + scaledWidth / 2;
          maxCenterX = viewport.right - scaledWidth / 2;
        } else {
          minCenterX = viewport.right - scaledWidth / 2;
          maxCenterX = viewport.left + scaledWidth / 2;
        }

        if (scaledHeight <= viewport.height) {
          minCenterY = viewport.top + scaledHeight / 2;
          maxCenterY = viewport.bottom - scaledHeight / 2;
        } else {
          minCenterY = viewport.bottom - scaledHeight / 2;
          maxCenterY = viewport.top + scaledHeight / 2;
        }

        this.zoomX = Math.min(maxCenterX - baseCenterX, Math.max(minCenterX - baseCenterX, this.zoomX));
        this.zoomY = Math.min(maxCenterY - baseCenterY, Math.max(minCenterY - baseCenterY, this.zoomY));
      }

      applyZoom() {
        if (!this.zoomImage) return;
        this.zoomImage.style.transform = `translate3d(${this.zoomX}px, ${this.zoomY}px, 0) scale(${this.zoomScale})`;
        this.appliedZoomX = this.zoomX;
        this.appliedZoomY = this.zoomY;
        this.zoomImage.classList.add('is-pinch-zoomed');
        this.updateZoomControls();
      }

      resetZoom() {
        if (this.zoomImage) {
          this.zoomImage.style.transform = '';
          this.zoomImage.classList.remove('is-pinch-zoomed');
        }
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;
        this.appliedZoomX = 0;
        this.appliedZoomY = 0;
        this.zoomImage = null;
      }
    }
  );
}
